import React from 'react';
import Img from 'gatsby-image';
import styled from 'styled-components';
import { mediaMax } from '../../utils/breakpoints';
import { Event } from '../../types/events';
import VersionOneEvent from './EventVersions/VersionOne';
import { Title, Abstract } from './components/Typography';
import { graphql, useStaticQuery } from 'gatsby';


export default( event  : any) => {
  const ThisEvent : Event = event.event;

  const data = useStaticQuery(
    graphql`
      query {
        Background: file(relativePath: { eq: "jolatonleikar_dagskra_spjold.png" }) {
          childImageSharp {
            fluid(quality: 100, maxWidth: 1800) {
              ...GatsbyImageSharpFluid_withWebp
            }
          }
        }
      }
    `
  )
  
  return (
    <EventWrapper>
      <StyledImage fluid={data.Background.childImageSharp.fluid}/>
      
      <Content>
        <TopContent>
          <StyledTitle>{ThisEvent.title}</StyledTitle>
          <Abstract dangerouslySetInnerHTML={{
            __html: ThisEvent.information
          }}></Abstract>

        </TopContent>

        <BottomContent>
          <VersionOneEvent event={ThisEvent}/>
        </BottomContent>
        
      </Content>
    </EventWrapper>
  )

}

const StyledImage = styled(Img)`
  height:100vh;
  width:100vw;
  position:absolute !important;
  z-index:-1;
  filter: blur(5px);
`

export const TopContent = styled.div`
  min-height:68vh;
  padding-left:calc(100vw * 0.092);
  background: linear-gradient(180deg, rgba(255,99,100,0) 100%, rgba(255,99,100,0.7) 100%, rgba(255,99,100,1) 100%);

  @media ${mediaMax.tablet} {
    padding: 80px 15px 0 15px;
    padding-right: 30%;
  }

  @media ${mediaMax.mobileL}{
    padding-right:15px;
  }
`

export const BottomContent = styled.div`
  min-height:30vh;
  background: rgba(255,99,100,0);
  padding-top: calc(100vw * 0.0583);
  padding-left:calc(100vw * 0.092);

  @media ${mediaMax.tablet}{
    width: 100vw;
    padding: 20px 15px 80px 15px;
  }
`

const EventWrapper = styled.div`
`

const Content = styled.div`
  width: 100vw;
  display: flex;
  flex-direction: column;
  position: relative;
  font-family: ${({theme}) => theme.fonts.fontFamilyPrimary};
`

const StyledTitle = styled(Title)`
  padding-top: calc(100vh * 0.254);

  @media ${mediaMax.tablet}{
    padding-top:100px;
  }
`